<template>
<Dialog :header="header" 
v-model:visible="show" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '80vw'}"
:modal="true"

>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>

<DataTable 
:value="versions" 
class="p-datatable-suppliers" 
:rowHover="true" 
responsiveLayout="scroll"
style="min-height: 300px;"
>

<template #empty>
    {{$store.state.languages.lang_phrases.sonuc_bulunamadi}}
</template>

<Column  :header="$store.state.languages.lang_phrases.deger" headerStyle="width: 24rem">
<template #body="{data}">

<template v-if="customattribute.type=='string'">
<p class="text-primary font-bold">{{data.attibutetextval}}</p>
</template>

<template v-if="customattribute.type=='number'">
<p class="text-primary font-bold">{{data.attibutenumericalval}}</p>
</template>

<template v-if="customattribute.type=='select'">
<p class="font-bold" :style="'color:#'+getOptionColor(data.attibutenumericalval)">{{getOptionValue(data.attibutenumericalval)}}</p>
</template>

<template v-if="customattribute.type=='multiselect'">
<p class="text-primary">
  <span class="mr-2 font-bold" 
  v-for="(option,i) in JSON.parse(data.attibutetextval)"
   :style="'color:#'+getOptionColor(option)"
  >
  {{getOptionValue(option)}}
  <template v-if="i<JSON.parse(data.attibutetextval).length-1">,</template>
</span>
</p>
</template>

<template v-if="customattribute.type=='boolean'">
  <template v-if="data.attibutenumericalval===0">
    <span class="material-symbols-outlined text-red-500 md-24 mt-2">do_not_disturb_on</span>
  </template>
  <template v-else-if="data.attibutenumericalval===1">
    <span class="material-symbols-outlined  text-green-500 md-24 mt-2">check_circle</span>
  </template>
  <template v-else>
    <span class="material-symbols-outlined text-red-500 md-24 mt-2">do_not_disturb_on</span>
  </template>
<p class="text-primary">{{data.attibutetextval}}</p>
</template>

</template>
</Column>

<Column  :header="$store.state.languages.lang_phrases.islem_yapan">
<template #body="{data}">
  <template v-if="data.submittedby">
    <p v-tooltip.left="{ value: data.submittedby.email, disabled: false,class: 'custom-top-tooltip' }">{{data.submittedby.name}}</p>
  </template>

</template>
</Column>

<Column  :header="$store.state.languages.lang_phrases.eylem">
<template #body="{data}">
<p class="font-bold" :style="'color:#'+getItemReasonColor(data.reason)">{{getItemReason(data.reason)}}</p>
</template>
</Column>

<Column  :header="$store.state.languages.lang_phrases.guncelleme_tarihi">
<template #body="{data}">
<p >{{ $filters.momentFormat( data.created_at," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

</DataTable>

  
</template>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-primary p-button-outlined  p-button-sm" />
</template>

</Dialog>
</template>

<script>
export default {

  name: 'SupplierAttributeHistory',

  data () {
    return {
    	show:false,
    	loading:true,
    	customattribute:null,
    	versions:[],
    }
  },
  computed:{
    header()
    {
      if(this.customattribute)
      {
        return this.getTheTranslation(this.customattribute,'translation')
      }
      return null
    }
  },
  methods:{
    getItemReason(reason)
    {
      let phrase
      if(reason=="manuel_override")
      {
        phrase = "manuel_islem"
      }
      if(reason=="questionlist_calculation")
      {
        phrase =  "asama_puani_hesaplama"
      }
      if(reason=="questionlist_condition")
      {
        phrase =  "soru_listesi_kosulu"
      }
      if(reason=="flow_automation")
      {
        phrase =  "asama_otomasyonu"
      }
      if(reason=="project_automation")
      {
        phrase =  "proje_otomasyonu"
      }
      if(reason=="report_override")
      {
        phrase =  "rapor_islemi"
      }
      return this.$store.state.languages.lang_phrases[phrase]
    },

    getItemReasonColor(reason)
    {
      let color
      if(reason=="manuel_override")
      {
        color = "352f8d"
      }
      if(reason=="questionlist_calculation")
      {
        color =  "ff6600"
      }
      if(reason=="questionlist_condition")
      {
        color =  "ff6600"
      }
      if(reason=="flow_automation")
      {
        color =  "3b82f6"
      }
      if(reason=="project_automation")
      {
        color =  "dd4b39"
      }
      if(reason=="report_override")
      {
        color =  "352f8d"
      }
      return color
    },
    getOptionValue(id)
    {
      let option = this.customattribute.options.find(item=>item.id == id)
      if(option)
      {
        return this.getTheTranslation(option,'translation')
      }
      return ""
    },
    getOptionColor(id)
    {
      let option = this.customattribute.options.find(item=>item.id == id)
      if(option && option.color)
      {
        return option.color
      }
      return "352f8d"
    },
  	hideModal()
  	{
  		this.show = false
      this.customattribute = null
      this.versions = []
  	},
  	async showModal(supplierattribute_id)
  	{
      this.show = true
  		this.loading = true
  		let data = this.attributes = await this.generalApiGetWithoutLoader("audit/get_supplier_attribute_history/"+supplierattribute_id)
      console.log("data")
      console.log(data)
  		this.customattribute = data.customattribute
  		this.versions = data.versions
  		this.loading = false
  	},
  }
}
</script>

<style lang="css" scoped>
</style>